import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "A pulse wave propagates in the air from left to right and/or from right to left. The velocity field and the pressure field are shown with arrows and colors respectively,and as a graph. The moving microphone records the pressure and velocity as a function of time (graph below). You can play with the amplitude and polarity of each wave. Feel free to pause the motion to freeze the situation and move the microphone (dark blue circle) to explore the time dependence of pressure and velocity at any point.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0103/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
